import { request } from '@/common';
import { HelperCore, HelpOther } from '@/common/helper';
import { makeAutoObservable, runInAction, toJS } from 'mobx';

class Store {
  planDataMap = {};
  actioning = false;

  constructor() {
    makeAutoObservable(this);
  }

  setPlanDataMap = (planStepId, value) => {
    runInAction(() => {
      this.planDataMap[planStepId] = value;
    });
  };
  updatePlanData = (planStepId, type, index, key, value) => {
    runInAction(() => {
      this.planDataMap[planStepId]?.content?.map((item, _index) => {
        if (item.type == type && _index == index) {
          item[key] = value;
        }
        return item;
      });
      if(this.planDataMap[planStepId]?.content[index]?.items?.length == 0){
        this.planDataMap[planStepId]?.content?.splice(index, 1);
      }
    });
  };
  handleAction = (formResult, reply_type, requestPlanParams) => {
    if (this.actioning) return Promise.reject({});
    this.actioning = true;

    const param = {
      ...requestPlanParams,
      reply: formResult,
      reply_type
    };
    return request
      .post('ai_agent/event_reply', param, {
        dataIsJson: true,
      })
      .then(res => {
        HelperCore.log(res);
        if (res.code == '420100') {
          HelpOther.toast('内容敏感，请重新编辑', 'error');
        }
        return res;
      })
      .catch(res => {
        if (res.code == '420100') {
          HelpOther.toast('内容敏感，请重新编辑', 'error');
        }
      })
      .finally(() => {
        runInAction(() => {
          this.actioning = false;
        });
      });
  };
}
const planQuestionStore = new Store();
export default planQuestionStore;
